import { Link, NavLink, useLocation } from 'react-router-dom';
import { Icon } from './Icon.js';
import type { Theme } from '../lib/theme.js';

const links = [
  { to: '/funcionalidades', label: 'Funcionalidades', icon: 'apps' },
  { to: '/comparar', label: 'Comparar', icon: 'balance' },
  { to: '/graficos', label: 'Gráficos', icon: 'bar_chart' },
  { to: '/metodologia', label: 'Metodologia', icon: 'menu_book' },
  { to: '/funcionalidades#brandnexx', label: 'brandnexx', icon: 'hub' },
];

const bottom = [
  { to: '/funcionalidades', label: 'Início', icon: 'apps' },
  { to: '/comparar', label: 'Comparar', icon: 'balance' },
  { to: '/calculos/salario', label: 'Salário', icon: 'payments', primary: true },
  { to: '/graficos', label: 'Gráficos', icon: 'bar_chart' },
  { to: '/holerite', label: 'Holerite', icon: 'document_scanner' },
];

const Brand = () => (
  <Link className="brand" to="/funcionalidades">
    <span className="brand-mark" aria-hidden><i /><i /><i /></span>
    amigo<em>do</em>clt
  </Link>
);

function ThemeButton({ theme, onToggle }: { theme: Theme; onToggle: () => void }) {
  return (
    <button type="button" className="icon-button" onClick={onToggle} aria-label={theme === 'dark' ? 'Usar tema claro' : 'Usar tema noturno'}>
      <Icon name={theme === 'dark' ? 'light_mode' : 'dark_mode'} size={20} />
    </button>
  );
}

export function Navbar({ theme, onToggleTheme }: { theme: Theme; onToggleTheme: () => void }) {
  const { pathname } = useLocation();
  const onSalary = pathname === '/calculos/salario';
  const isHub = pathname === '/funcionalidades';
  const printable = pathname.startsWith('/calculos') || pathname === '/comparar';

  return (
    <>
      <header className="nav-desktop">
        <nav className="nav-pill glass-nav" aria-label="Principal">
          <Brand />
          <div className="nav-links">
            {links.map((link) => (
              <NavLink key={link.to} to={link.to} end={link.to === '/funcionalidades'} className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}>
                <Icon name={link.icon} size={18} /><span>{link.label}</span>
              </NavLink>
            ))}
          </div>
          <div className="nav-tools">
            <ThemeButton theme={theme} onToggle={onToggleTheme} />
            <Link to="/calculos/salario" className={`nav-cta${onSalary ? ' current' : ''}`}>
              <Icon name="calculate" size={20} fill={onSalary} />Calcular salário
            </Link>
          </div>
        </nav>
      </header>

      <header className="nav-mobile-top app-header">
        {isHub ? <Brand /> : (
          <Link className="nav-back" to="/funcionalidades"><Icon name="arrow_back" size={22} />Funcionalidades</Link>
        )}
        <div className="nav-tools">
          <ThemeButton theme={theme} onToggle={onToggleTheme} />
          {printable ? (
            <button type="button" className="icon-button" onClick={() => window.print()} aria-label="Imprimir"><Icon name="print" size={20} /></button>
          ) : (
            <Link to="/metodologia" className="icon-button" aria-label="Metodologia"><Icon name="menu_book" size={20} /></Link>
          )}
        </div>
      </header>

      <nav className="bottom-pill" aria-label="Navegação principal">
        <div className="bottom-pill-inner">
          {bottom.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) => `bottom-item${item.primary ? ' primary' : isActive ? ' active' : ''}`}
            >
              {({ isActive }) => (
                <>
                  <Icon name={item.icon} size={item.primary ? 24 : 22} fill={item.primary || isActive} />
                  {item.label}
                </>
              )}
            </NavLink>
          ))}
        </div>
      </nav>
    </>
  );
}
